import api from "../api/axios";

// Get goal cycle configs by company ID
export const getGoalCycleConfigsByCompanyId = async (companyId) => {
  try {
    const response = await api.get(`api/goal/companies/${companyId}/goal-cycle-configs`);
    return response.data;
  } catch (error) {
    console.error("Error fetching goal cycle configs:", error);
    throw error;
  }
};

// Get single goal cycle config by ID
export const getGoalCycleConfigById = async (id) => {
  try {
    const response = await api.get(`api/goal/goal-cycle-configs/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching goal cycle config by ID:", error);
    throw error;
  }
};

// Create new goal cycle config
export const createGoalCycleConfig = async (data) => {
  try {
    const response = await api.post("api/goal/goal-cycle-configs", data);
    return response.data;
  } catch (error) {
    console.error("Error creating goal cycle config:", error);
    throw error;
  }
};

// Update goal cycle config
export const updateGoalCycleConfig = async (id, data) => {
  try {
    const response = await api.put(`api/goal/goal-cycle-configs/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating goal cycle config:", error);
    throw error;
  }
};

// Delete goal cycle config (soft delete)
export const deleteGoalCycleConfig = async (id) => {
  try {
    const response = await api.delete(`api/goal/goal-cycle-configs/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting goal cycle config:", error);
    throw error;
  }
};

// Update goal creation status
export const updateGoalCreationStatus = async (id, status) => {
  try {
    const response = await api.patch(
      `api/goal/goal-cycle-configs/${id}/goal-creation-status`,
      { status }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating goal creation status:", error);
    throw error;
  }
};

// Get departments for a goal cycle
export const getGoalCycleDepartments = async (id) => {
  try {
    const response = await api.get(`api/goal/goal-cycle-configs/${id}/departments`);
    return response.data;
  } catch (error) {
    console.error("Error fetching goal cycle departments:", error);
    throw error;
  }
};
